<template>
	<div class="closeout-filters card mb-4">
		<div class="card-body">
			<h5 class="card-title mb-3">Search Filters</h5>
			<div class="row g-3 align-items-end">
				<div class="col-12 col-md-3">
					<label class="form-label fw-bold">Keyword</label>
					<input
						:value="filters.search"
						type="text"
						class="form-control"
						placeholder=""
						@input="
							$emit('update:filters', { ...filters, search: $event.target.value })
						"
						@keyup.enter="$emit('apply')"
					/>
				</div>
				<div class="col-12 col-md-3">
					<label class="form-label fw-bold">Category</label>
					<select
						:value="filters.category"
						class="form-select"
						@change="
							$emit('update:filters', { ...filters, category: $event.target.value })
						"
					>
						<option value="">All</option>
						<option v-for="cat in categories" :key="cat.slug" :value="cat.slug">
							{{ cat.name }}
						</option>
					</select>
				</div>
				<div class="col-12 col-md-3">
					<label class="form-label fw-bold">Manufacturer</label>
					<select
						:value="filters.manufacturer"
						class="form-select"
						@change="
							$emit('update:filters', {
								...filters,
								manufacturer: $event.target.value,
							})
						"
					>
						<option value="">All</option>
						<option v-for="mfg in manufacturers" :key="mfg.slug" :value="mfg.slug">
							{{ mfg.name }}
						</option>
					</select>
				</div>
				<div class="col-12 col-md-3">
					<label class="form-label fw-bold">Minimum Available Qty</label>
					<input
						:value="filters.minQty"
						type="number"
						class="form-control"
						min="0"
						placeholder="1"
						@input="
							$emit('update:filters', {
								...filters,
								minQty: Number($event.target.value),
							})
						"
						@keyup.enter="$emit('apply')"
					/>
				</div>
			</div>
			<div class="row mt-3">
				<div class="col-12">
					<p class="text-muted fst-italic mb-3">
						Note: Prices limited to current inventory while supplies last. All products
						not available in all areas. All sales are final. No returns will be
						accepted.
					</p>
					<div class="d-flex gap-2 justify-content-end">
						<button class="btn btn-outline-secondary" @click="$emit('clear')">
							CLEAR ALL
						</button>
						<button class="btn btn-primary" @click="$emit('apply')">
							APPLY FILTERS
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CloseoutFilters',
	props: {
		filters: { type: Object, required: true },
		categories: { type: Array, default: () => [] },
		manufacturers: { type: Array, default: () => [] },
	},
	emits: ['update:filters', 'apply', 'clear'],
};
</script>
